var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-btn',{attrs:{"id":"back-to-top-btn","color":"primary","fab":"","fixed":"","bottom":"","right":""},on:{"click":function($event){return _vm.$vuetify.goTo(_vm.target, _vm.options)}}},[_c('v-icon',[_vm._v("mdi-chevron-up")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }